import urls, { prefetchConfig } from "../urls";

export default {
  // 获取商品基本信息
  asyncGetProductDetailBase: prefetchConfig(urls.getProductDetailBase, {
    spuId: "$query.spuId",
    skuId: "$query.skuId",
  }),
  // 商详—图文详情
  asyncGetUserAddressList: prefetchConfig(urls.getProvinces, {
    countryId: "1",
  }),
  // // 商详—用户默认有效地址
  // asyncGetUserDefaultAddress: prefetchConfig(urls.getProductDetailBase, {
  //   spuId: "$query.spuId",
  //   skuId: "$query.skuId",
  // }),
  // 商详-分享ActionKey接口
  // asyncGetShareParams: prefetchConfig(urls.getShareParams, { content: "$location.href", appTarget: "wisecart" }),
};
